/*
 * FOR SALE — vitrine (bxkr8z-uk). Aucun achat, aucun panier, aucune réservation.
 * Catalogue : annonces Discord réelles rendues par Liquid (lien Discord seulement), sinon démonstration fictive.
 * Le bloc [data-fs-commerce] n'est jamais animé ni modifié par ce script.
 *
 * Écrans et adresses (refonte premium, rôle 3) — une seule page, l'adresse dit toujours l'écran :
 * - accueil : l'adresse de la page sans paramètre géré (jamais ?game=default) ; « Toutes les annonces » (catalogue
 *   « Tous les jeux ») y ajoute #fs-catalog ;
 * - écran d'un jeu : ?game=<jeu> (habillage du pack s'il existe, voix, catalogue du jeu). Toutes les entrées d'un
 *   jeu y mènent de la même façon : tuile du portail, rubrique « Jeu » des filtres (FSNav.pick), fil d'Ariane de la
 *   fiche. L'ancien filtre sans habillage ?jeu=<jeu> est réécrit en ?game=<jeu> (liens déjà partagés) ;
 * - fiche : annonce Discord (métaobjet) → sa page /pages/listings/<handle> (lien « Voir l'annonce » de la carte) ; l'ancienne
 *   adresse &listing=<handle> y renvoie. Démonstration fictive (blocs, flux) : &listing=<handle> (sinon
 *   <jeu>-<référence>), fiche en dialogue par-dessus l'écran où elle s'ouvre ;
 * - formulaire : #sell (le jeu reste celui de l'écran).
 * Historique : une entrée par écran (pushState) ; filtres, recherche et tri remplacent l'entrée (fs-filters.js).
 * Un seul popstate rétablit écran, jeu du catalogue, fiche, filtres (FSListingFilters.syncFromUrl), position
 * (history.state.y, défilement manuel) et focus.
 * La fiche se ferme au Précédent ; ouverte directement, sa fermeture retire &listing= (aucun history.back()).
 * « fs-game » (session) n'est qu'une préférence : la tuile du dernier jeu porte data-fs-last, rien ne redirige.
 *
 * Contrats exposés :
 * - racine [data-fs-demo] : data-fs-catalog-game = jeu du catalogue ('all' ou code), lu par fs-filters.js ;
 * - window.FSNav = { state(), href(target, options), pick(game, options), closeDetail(), enter(section) } ; pick : entrée
 *   dans un jeu (« all » : tous les jeux) depuis le catalogue, sans remonter en haut de page ; événements fs:detail-open
 *   { handle, game, reference } et fs:detail-close { handle } ;
 * - liens interceptés : [data-fs-world] (tuile), [data-fs-nav-game] (écran d'un jeu), [data-fs-nav="home"],
 *   [data-fs-show-all] (« Toutes les annonces » depuis l'écran d'un jeu),
 *   [data-fs-crumb="home"|"game"] et [data-fs-detail-back] (fiche), [data-fs-portal-open] (« Changer de jeu »),
 *   [data-fs-gate-all] (« Toutes les annonces »), [data-fs-propose-open] (entrée #sell, fs-propose.js garde la main) ;
 * - habillage : data-fs-game-skin="<jeu>" sur la racine, pack et fs-game-skin.css injectés à ce moment ;
 *   événement fs:game-skin-change { game, previous } et window.FSGameSkin (get, packs, data) ; chaque carte d'annonce
 *   d'un jeu doté d'un pack porte data-fs-card-skin="<jeu>" (accent, icônes, vaisseaux ; cadre FOR SALE commun).
 *   Aucun fond d'univers (ni canvas ni affiche) : fond uni en CSS.
 * Défilements : tous explicites ; animés seulement après un clic et hors mouvement réduit, instantanés sinon.
 */
(() => {
  /* Textes : dictionnaire de la langue de la page (fs-i18n-<langue>.js, script différé chargé avant celui-ci ; sous
     Node, posé par le test). Clé absente ou dictionnaire manquant : la clé elle-même, jamais un texte français. */
  const t = (key, params) => (globalThis.fsI18n ? globalThis.fsI18n.t(key, params) : key);
  /* ---- Adresses : noyau pur (aucun DOM), testé par tools/universe-lab/navigation.test.mjs ---- */
  const navCore = (() => {
    const GAME = /^[a-z0-9-]{1,40}$/;
    const HANDLE = /^[a-z0-9][a-z0-9-]{0,99}$/;
    const MANAGED_FILTERS = ['f', 'q', 'sort'];
    /** Code de jeu valide, '' sinon (« default » n'est pas un jeu). */
    const game = (value) => {
      const text = String(value ?? '').trim().toLowerCase();
      return GAME.test(text) && text !== 'default' && !(globalThis.FSComingSoonGames ?? ['darkorbit']).includes(text) ? text : '';
    };
    const handle = (value) => {
      const text = String(value ?? '').trim().toLowerCase();
      return HANDLE.test(text) ? text : '';
    };
    const migrate = (url) => {
      const aliases = { univers: 'game', jeu: 'game', annonce: 'listing', modifier: 'edit', corriger: 'resubmit', comparer: 'compare', tri: 'sort' };
      for (const [old, current] of Object.entries(aliases)) {
        if (!url.searchParams.has(old)) continue;
        if (!url.searchParams.has(current)) url.searchParams.set(current, url.searchParams.get(old));
        url.searchParams.delete(old);
      }
      url.hash = ({ '#proposer': '#sell', '#mes-annonces': '#my-listings', '#mes-achats': '#my-purchases', '#fs-catalogue': '#fs-catalog' })[url.hash] || url.hash;
      return url;
    };
    /** Écran demandé par une adresse : { univers, annonce, hash } ('' = absent). */
    const parse = (href) => {
      const url = migrate(new URL(href));
      return {
        univers: game(url.searchParams.get('game')),
        annonce: handle(url.searchParams.get('listing')),
        hash: url.hash.length > 1 ? url.hash : '',
      };
    };
    /** Adresse d'un écran : paramètres gérés réécrits ; les autres (labo, service…) gardés ; f/q/tri gardés sur demande
        (keepFilters : true = les trois, ou liste de noms, ex. ['q', 'sort'] au changement de jeu). */
    const build = (href, { univers = '', annonce = '', hash = '' } = {}, { keepFilters = false } = {}) => {
      const url = migrate(new URL(href));
      const put = (name, value) => (value ? url.searchParams.set(name, value) : url.searchParams.delete(name));
      put('game', game(univers));
      url.searchParams.delete('jeu');
      put('listing', handle(annonce));
      const kept = keepFilters === true ? MANAGED_FILTERS : Array.isArray(keepFilters) ? keepFilters.map((name) => name === 'tri' ? 'sort' : name) : [];
      MANAGED_FILTERS.filter((name) => !kept.includes(name)).forEach((name) => url.searchParams.delete(name));
      url.hash = typeof hash === 'string' && hash.length > 1 && hash.startsWith('#') ? hash : '';
      return url.href;
    };
    /** Adresse canonique (univers=default, univers vide et #MainContent retirés ; ancien ?jeu=<jeu> → ?game=<jeu>,
        filtres gardés : ce sont ceux du même jeu) ; null si rien ne change. */
    const canonical = (href) => {
      const url = migrate(new URL(href));
      let changed = url.href !== href;
      const univers = url.searchParams.get('game');
      if (univers !== null && !game(univers)) { url.searchParams.delete('game'); changed = true; }
      if (url.searchParams.has('jeu')) {
        const legacy = game(url.searchParams.get('jeu'));
        if (legacy && !url.searchParams.has('game')) url.searchParams.set('game', legacy);
        url.searchParams.delete('jeu');
        changed = true;
      }
      if (url.searchParams.has('listing') && !handle(url.searchParams.get('listing'))) { url.searchParams.delete('listing'); changed = true; }
      if (url.hash === '#MainContent') { url.hash = ''; changed = true; }
      return changed ? url.href : null;
    };
    /** Identifiant d'adresse d'une annonce : handle du métaobjet, sinon <jeu>-<référence> (décision 004). */
    const handleOf = ({ handle: given, game: code, reference } = {}) => {
      const own = handle(given);
      if (own) return own;
      const ref = String(reference ?? '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      return ref && game(code) ? handle(`${game(code)}-${ref}`) : '';
    };
    /** L'annonce demandée correspond-elle à cette carte ? handle exact, ou référence seule (?listing=acc021). */
    const matches = (wanted, card) => {
      const value = handle(wanted);
      if (!value) return false;
      if (value === handleOf(card)) return true;
      const ref = handleOf({ game: 'x', reference: card?.reference }).slice(2);
      return Boolean(ref) && value === ref;
    };
    /** Titre du document. */
    const title = ({ gameName = '', detail = '', reference = '' } = {}) => {
      if (detail) return `${detail}${reference && !detail.includes(reference) ? ` · ${reference}` : ''} — Space Syndicate`;
      return gameName ? t('meta.site.title_game', { game: gameName }) : t('meta.site.title');
    };
    return Object.freeze({ game, handle, parse, build, canonical, handleOf, matches, title });
  })();
  if (typeof document === 'undefined') {
    globalThis.FSNavCore = navCore;
    return;
  }

  const DEFAULT_UNIVERSE = 'default';
  const pad = (value, size = 2) => String(value).padStart(size, '0');
  const reducedMotion = () => document.documentElement.dataset.fsMotion === 'reduced'
    || (typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches);
  /* Une seule page par document : identifiant des entrées d'historique poussées par ce chargement. */
  const docId = Math.random().toString(36).slice(2);

  const readRegistry = () => {
    try {
      const list = JSON.parse(document.getElementById('fs-universe-data')?.textContent || '[]');
      return new Map((Array.isArray(list) ? list : [])
        .filter((item) => item && typeof item.id === 'string')
        .map((item) => [item.id, item]));
    } catch {
      return new Map();
    }
  };

  /* Coordonnées fictives et stables par univers : micro-détail éditorial, sans valeur informative. */
  const coordinates = (id) => {
    let hash = 2166136261;
    for (const char of id) hash = Math.imul(hash ^ char.codePointAt(0), 16777619) >>> 0;
    const lat = hash % 90; const latMin = (hash >>> 7) % 60;
    const lon = (hash >>> 13) % 180; const lonMin = (hash >>> 21) % 60;
    return `${pad(lat)}°${pad(latMin)}′${hash & 1 ? 'N' : 'S'} · ${pad(lon, 3)}°${pad(lonMin)}′${hash & 2 ? 'E' : 'O'}`;
  };

  /* View Transition typée (« fs-universe », « fs-detail ») : fs-universe.css ne stylise que les siennes.
     Navigateurs sans types (forme objet refusée) : forme fonction, la portée .fs-immersive suffit. */
  const startTransition = (update, type) => {
    let transition;
    try { transition = document.startViewTransition({ update, types: [type] }); } catch { transition = document.startViewTransition(update); }
    /* Une transition sautée (nouvel appel, autre transition) rejette ces promesses : sans conséquence. */
    transition.ready.catch(() => {});
    transition.updateCallbackDone.catch(() => {});
    return transition;
  };

  const initialise = async (root) => {
    if (root.dataset.fsReady) return;
    root.dataset.fsReady = 'true';
    if (root.dataset.fsSource === 'feed') {
      if (!window.ForSaleCatalog) {
        root.querySelector('[data-fs-feed-status]').textContent = t('home.catalogue.unavailable');
        root.querySelector('[data-fs-catalog-content]').setAttribute('aria-busy', 'false');
        const worldStatus = root.querySelector('[data-fs-world-loading]');
        if (worldStatus) worldStatus.textContent = t('home.catalogue.worlds_unavailable');
        return;
      }
      if (!await window.ForSaleCatalog.load(root)) return;
      if (!root.isConnected) return;
    }

    const registry = readRegistry();
    const cards = [...root.querySelectorAll('[data-fs-offer]')];
    const count = root.querySelector('[data-fs-count]');
    const empty = root.querySelector('[data-fs-empty]');
    const dialog = root.querySelector('[data-fs-dialog]');
    const detail = root.querySelector('[data-fs-detail]');
    const emblems = root.querySelector('[data-fs-emblems]');
    const hero = root.querySelector('[data-fs-hero]');
    const catalogue = root.querySelector('#fs-catalog');
    const voice = {
      eyebrow: root.querySelector('[data-fs-voice-eyebrow]'),
      title: root.querySelector('[data-fs-voice-title]'),
      tagline: root.querySelector('[data-fs-voice-tagline]'),
    };
    /* Textes d'origine : sauvegardés par le script d'avant-rendu quand ?game= a déjà posé la voix. */
    const original = (key) => hero?.getAttribute(`data-fs-default-${key}`) ?? voice[key]?.textContent ?? '';
    const defaults = { eyebrow: original('eyebrow'), title: original('title'), tagline: original('tagline') };

    /* ---- Habillage par jeu (packs injectés pour le jeu de l'écran et pour les jeux des annonces affichées) ---- */
    const packTemplates = new Map([...root.querySelectorAll('template[data-fs-pack-template]')]
      .map((template) => [template.dataset.fsPackTemplate, template]));
    const ensureSkinCss = () => {
      const href = root.dataset.fsSkinCss;
      const existing = document.querySelector('link[data-fs-skin-css]');
      if (existing || !href) return existing;
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.setAttribute('data-fs-skin-css', '');
      document.head.append(link);
      return link;
    };
    const loadPack = (game) => {
      const template = packTemplates.get(game);
      if (!template || template.hasAttribute('data-fs-pack-loaded')) return;
      template.setAttribute('data-fs-pack-loaded', '');
      document.head.append(template.content.cloneNode(true));
    };
    const packData = (game) => {
      const read = (node) => { try { return node ? JSON.parse(node.textContent) : null; } catch { return null; } };
      return read(document.getElementById(`fs-game-pack-${game}`))
        || read(packTemplates.get(game)?.content.querySelector(`#fs-game-pack-${game}`));
    };
    const remember = (universe) => {
      try {
        if (universe && universe !== DEFAULT_UNIVERSE) sessionStorage.setItem('fs-game', universe);
      } catch { /* session indisponible : préférence non gardée */ }
    };

    /* Titre du document : celui de l'écran, remplacé par celui de la fiche tant qu'elle est ouverte. */
    let screenTitle = navCore.title();
    const showTitle = () => { if (!dialog?.open) document.title = screenTitle; };
    const applySkin = (universe) => {
      const game = packTemplates.has(universe) ? universe : '';
      const previous = root.getAttribute('data-fs-game-skin') || '';
      if (game) {
        ensureSkinCss();
        loadPack(game);
        root.setAttribute('data-fs-game-skin', game);
      } else root.removeAttribute('data-fs-game-skin');
      const name = game ? packData(game)?.name : '';
      screenTitle = navCore.title({ gameName: typeof name === 'string' ? name : '' });
      showTitle();
      if (previous !== game) {
        document.dispatchEvent(new CustomEvent('fs:game-skin-change', { detail: { game: game || null, previous: previous || null } }));
      }
    };
    window.FSGameSkin = Object.freeze({
      get: () => root.getAttribute('data-fs-game-skin') || null,
      packs: () => [...packTemplates.keys()],
      data: (game) => (packTemplates.has(game) ? packData(game) : null),
    });
    /* Cartes d'annonces des jeux dotés d'un pack : data-fs-card-skin="<jeu>" (accent, icônes et vaisseaux du pack, cadre
       FOR SALE inchangé : fs-game-skin.css, fs-design-showcase.css). Posé seulement une fois fs-game-skin.css chargée :
       jusque-là, et si elle échoue, la carte garde son rendu neutre. Exemples fictifs exclus. */
    const skinCards = () => {
      const listings = cards.filter((card) => card.hasAttribute('data-fs-listing') && packTemplates.has(card.dataset.game));
      if (!listings.length) return;
      const link = ensureSkinCss();
      if (!link) return;
      new Set(listings.map((card) => card.dataset.game)).forEach(loadPack);
      const apply = () => listings.forEach((card) => card.setAttribute('data-fs-card-skin', card.dataset.game));
      if (link.sheet) apply();
      else link.addEventListener('load', apply, { once: true });
    };

    /* Tuiles de l'accueil : préchargement discret de la feuille d'habillage à l'approche. */
    const tiles = [...root.querySelectorAll('[data-fs-gate]')];
    tiles.forEach((tile) => {
      const warm = () => { if (packTemplates.has(tile.dataset.fsGate)) ensureSkinCss(); };
      tile.addEventListener('pointerenter', warm, { once: true });
      tile.addEventListener('focusin', warm, { once: true });
    });

    /* Jeux de l'accueil (une tuile par jeu, jeux sans annonce compris : catalogue vide et message dédié), dans l'ordre
       d'affichage. */
    const games = new Map();
    tiles.forEach((tile) => {
      const id = tile.dataset.fsGate;
      if (!navCore.game(id) || games.has(id)) return;
      const name = tile.querySelector('.fs-home-game-name, .fs-gate-name')?.textContent.trim() || id;
      games.set(id, { id, name, index: games.size + 1, tagline: '' });
    });
    root.querySelectorAll('[data-fs-world]').forEach((link) => {
      const game = games.get(link.dataset.fsWorld);
      const tagline = link.closest('[data-fs-gate], .fs-world')?.querySelector('.fs-home-game-tagline, .fs-gate-tagline, .fs-world-bottom > p')?.textContent;
      if (game && tagline) game.tagline = tagline.trim();
    });
    const universeOf = (game) => (game !== 'all' && registry.has(game) ? game : DEFAULT_UNIVERSE);
    const gameOf = (universe) => (games.has(universe) ? universe : 'all');
    const nameOf = (game) => games.get(game)?.name || registry.get(game)?.name || game;

    /* current : jeu du catalogue (filtre) ; screen : jeu de l'écran (univers, habillage, voix). */
    let current = 'all';
    let screen = 'all';
    let opener;

    /* Annonces Discord réelles (data-fs-source="listings") : le compteur dit combien sont affichées
       et, si le plafond par univers s'applique, combien sont publiées (data-fs-total de la tuile ou de l'accueil). */
    const listings = root.dataset.fsSource === 'listings';
    const listingCount = (visible, game) => {
      const node = game === 'all' ? root.querySelector('[data-fs-all-count]') : root.querySelector(`[data-fs-gate="${CSS.escape(game)}"] [data-fs-gate-count]`);
      const total = Number(node?.dataset.fsTotal);
      return Number.isSafeInteger(total) && total > visible
        ? t('home.catalogue.count_of', { count: visible, total })
        : t('common.listings_count', { count: visible });
    };

    /* Jeu du catalogue : cartes et data-fs-catalog-game (lu par fs-filters.js, y compris pour un jeu sans annonce : ses
       cartes restent toutes masquées, jamais celles des autres jeux). */
    const filter = (game) => {
      current = game;
      root.dataset.fsCatalogGame = game;
      let visible = 0;
      cards.forEach((card) => {
        card.hidden = game !== 'all' && card.dataset.game !== game;
        if (!card.hidden) visible += 1;
      });
      if (count) count.textContent = listings ? listingCount(visible, game) : t('home.catalogue.examples_count', { count: visible });
      if (empty) empty.hidden = visible > 0;
    };

    const logos = root.querySelector('template[data-fs-logos]');
    /* Logo d'un jeu pour un emplacement : « logotype » (titre) ou « emblem » (puce), sinon le premier logo du jeu. */
    const logoFor = (universe, kind = 'logotype') => {
      const id = CSS.escape(universe);
      return (logos?.content.querySelector(`[data-fs-logo="${id}"][data-fs-logo-kind="${CSS.escape(kind)}"]`)
        || logos?.content.querySelector(`[data-fs-logo="${id}"]`))?.cloneNode(true) ?? null;
    };
    const emblemFor = (universe) => {
      const items = emblems?.content ? [...emblems.content.children] : [];
      const match = items.find((item) => item.dataset.fsEmblem === universe) || items.find((item) => item.dataset.fsEmblem === DEFAULT_UNIVERSE);
      return match ? match.cloneNode(true) : null;
    };

    let themeTimer = 0;
    const syncThemeColor = (universe) => {
      const meta = document.querySelector('meta[name="theme-color"]');
      const color = registry.get(universe)?.palette?.bg;
      if (!meta || typeof color !== 'string' || !/^#[0-9a-f]{3,8}$/i.test(color)) return;
      clearTimeout(themeTimer);
      themeTimer = setTimeout(() => meta.setAttribute('content', color), reducedMotion() ? 0 : 320);
    };

    /* Voix de l'écran : textes du hero, emblèmes et micro-détails. Appelée dans la View Transition. */
    const speak = (game) => {
      const info = game === 'all' ? null : games.get(game);
      const universe = info ? universeOf(game) : DEFAULT_UNIVERSE;
      const entry = registry.get(universe);
      if (hero) hero.dataset.fsVoice = info ? 'universe' : 'default';
      if (voice.eyebrow) voice.eyebrow.textContent = info ? (entry?.voice?.eyebrow || t('home.catalogue.universe_index', { index: pad(info.index) })) : defaults.eyebrow;
      if (voice.title) voice.title.textContent = info ? info.name : defaults.title;
      if (voice.tagline) voice.tagline.textContent = info ? (entry?.voice?.tagline || info.tagline || defaults.tagline) : defaults.tagline;
      root.querySelectorAll('[data-fs-hero-emblem], [data-fs-hero-sigil]').forEach((slot) => {
        const mark = emblemFor(universe);
        if (mark) slot.replaceChildren(mark);
      });
      /* Logo officiel du jeu (vide sinon : l'emblème reprend sa place). */
      root.querySelectorAll('[data-fs-hero-logo]').forEach((slot) => {
        const logo = info ? logoFor(universe, slot.dataset.fsHeroLogo || 'logotype') : null;
        if (logo) slot.replaceChildren(logo);
        else slot.replaceChildren();
      });
      const set = (selector, text) => root.querySelectorAll(selector).forEach((element) => { element.textContent = text; });
      set('[data-fs-hud-index]', info ? `U/${pad(info.index)}` : 'U/00');
      set('[data-fs-hud-sector]', info ? info.name.toLocaleUpperCase(document.documentElement.lang || undefined) : t('home.catalogue.origin'));
      set('[data-fs-hud-coord]', info ? coordinates(info.id) : '00°00′N · 000°00′E');
      set('[data-fs-active-name]', info ? info.name : 'Space Syndicate');
      set('[data-fs-active-index]', info ? pad(info.index, 3) : '000');
      /* Titre du document : nom du jeu de l'écran, avec ou sans pack (applySkin ne connaît que les jeux à pack). */
      screenTitle = navCore.title({ gameName: info ? info.name : '' });
      showTitle();
      syncCounts();
      syncThemeColor(universe);
    };

    /* Repli sans moteur : même contrat (attribut + événement + URL), View Transition si permise. */
    const fallbackSet = (universe, source, viewTransition = true) => {
      const previous = root.dataset.fsUniverse || DEFAULT_UNIVERSE;
      try {
        const url = new URL(window.location.href);
        if (universe === DEFAULT_UNIVERSE) url.searchParams.delete('game'); else url.searchParams.set('game', universe);
        if (url.href !== window.location.href) history.replaceState(history.state, '', url.href);
      } catch { /* URL non modifiable : sans conséquence. */ }
      if (previous === universe) return;
      const commit = () => {
        document.querySelectorAll('[data-fs-universe-root]').forEach((element) => element.setAttribute('data-fs-universe', universe));
        applySkin(universe);
        document.dispatchEvent(new CustomEvent('fs:universe-change', { detail: { id: universe, previous, source } }));
      };
      if (viewTransition && typeof document.startViewTransition === 'function' && !reducedMotion() && !document.hidden) {
        try { startTransition(commit, 'fs-universe'); return; } catch { /* repli immédiat */ }
      }
      commit();
    };
    const setUniverse = (universe, source, viewTransition) => {
      if (window.FSUniverse && typeof window.FSUniverse.set === 'function') {
        try { window.FSUniverse.set(universe, { source, viewTransition }); return; } catch { /* repli */ }
      }
      fallbackSet(universe, source, viewTransition);
    };

    /* Univers posé (événement, éventuellement dans la View Transition) : voix et suite de la navigation. */
    let pending = null;
    let pendingTimer = 0;
    let afterUniverse = null;
    const settle = () => {
      clearTimeout(pendingTimer);
      if (pending !== null) {
        const game = pending;
        pending = null;
        speak(game);
      }
      const then = afterUniverse;
      afterUniverse = null;
      then?.();
    };

    /* ---- Écrans ---- */
    /* Écran demandé { univers, annonce } : univers (racine, habillage, voix), jeu du catalogue, fiche. Un jeu de
       l'accueil hors du registre des univers (code inconnu du thème) a son écran et son catalogue, sur l'univers neutre.
       `then` s'exécute une fois l'univers posé (dans la View Transition s'il y en a une). */
    const screenOf = (target) => {
      const code = navCore.game(target.univers);
      const universe = code && registry.has(code) ? code : DEFAULT_UNIVERSE;
      return { universe, game: code && games.has(code) ? code : (universe === DEFAULT_UNIVERSE ? 'all' : gameOf(universe)) };
    };
    const show = (target, { animate = false, then = null } = {}) => {
      const { universe, game: catalog } = screenOf(target);
      screen = catalog;
      if (current !== catalog || root.dataset.fsCatalogGame !== catalog) filter(catalog);
      markLast();
      const done = () => { syncDetail(target.annonce || ''); then?.(); };
      if ((root.dataset.fsUniverse || DEFAULT_UNIVERSE) === universe) {
        applySkin(universe);
        remember(universe);
        speak(screen);
        done();
        return;
      }
      pending = screen;
      afterUniverse = done;
      clearTimeout(pendingTimer);
      setUniverse(universe, 'fs-nav', animate && !reducedMotion());
      /* Aucun événement (moteur absent, transition sautée) : la suite part quand même. */
      if (pending !== null || afterUniverse) pendingTimer = setTimeout(settle, 450);
    };

    document.addEventListener('fs:universe-change', (event) => {
      if (!root.isConnected) return;
      if (typeof event.detail?.id === 'string') {
        applySkin(event.detail.id);
        remember(event.detail.id);
      }
      if (pending !== null || afterUniverse) { settle(); return; }
      const universe = event.detail?.id;
      if (typeof universe !== 'string' || universe === universeOf(screen)) return;
      /* Changement venu d'ailleurs (autre composant) : l'écran, le catalogue et la voix suivent. */
      screen = gameOf(universe);
      filter(screen);
      speak(screen);
    });

    /* ---- Historique ---- */
    try { history.scrollRestoration = 'manual'; } catch { /* restauration native */ }
    const entry = () => (history.state && typeof history.state === 'object' ? history.state : {});
    /* Élément à refocaliser au retour, décrit sans référence au DOM (l'état survit au rechargement). */
    const focusKey = (element) => {
      if (!element || element === document.body || !root.contains(element)) return '';
      const card = element.closest('[data-fs-offer]');
      if (card && element.matches('[data-fs-open]')) return `open:${cardHandle(card) || cards.indexOf(card)}`;
      if (element.matches('[data-fs-pick-game]')) return `pick:${element.dataset.fsPickGame}`;
      if (element.matches('[data-fs-world]')) return `world:${element.dataset.fsWorld}`;
      if (element.id) return `id:${element.id}`;
      return '';
    };
    const findFocus = (key) => {
      if (typeof key !== 'string' || !key) return null;
      const [kind, value] = [key.slice(0, key.indexOf(':')), key.slice(key.indexOf(':') + 1)];
      if (kind === 'open') {
        const card = cards.find((item, index) => cardHandle(item) === value || String(index) === value);
        return card?.querySelector('[data-fs-open]') ?? null;
      }
      if (kind === 'pick') return root.querySelector(`[data-fs-pick-game="${CSS.escape(value)}"]`);
      if (kind === 'world') return [...root.querySelectorAll('[data-fs-world]')].find((link) => link.dataset.fsWorld === value) ?? null;
      if (kind === 'id') return document.getElementById(value);
      return null;
    };
    const writeEntry = (state, href = window.location.href) => {
      try { history.replaceState(state, '', href); } catch { /* quota d'historique : état non gardé */ }
    };
    /* Position et focus de l'entrée courante, gardés avant de la quitter (et à la fin de chaque défilement). */
    const mark = (focus) => {
      writeEntry({ ...entry(), fs: 1, y: Math.round(window.scrollY), focus: focusKey(focus ?? document.activeElement) });
    };
    const push = (href, state = {}, focus) => {
      mark(focus);
      try { history.pushState({ fs: 1, y: Math.round(window.scrollY), ...state }, '', href); } catch { writeEntry({ fs: 1, ...state }, href); }
    };
    const replace = (href, state = {}) => writeEntry({ ...entry(), fs: 1, ...state }, href);
    let scrollTimer = 0;
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => { if (!dialog?.open) mark(); }, 200);
    }, { passive: true });
    /* Sortie de la page : l'entrée est écrite au clic sur un lien, page encore active. Jamais dans un pagehide qui met
       la page en cache de navigation (persisted) : la page y est déjà inactive (pré-rendu activé, autre site), et un
       replaceState à ce moment l'en évince (IgnoreEventAndEvict) ; Précédent la rechargerait au lieu de la restaurer. */
    document.addEventListener('click', (event) => {
      if (!dialog?.open && event.target?.closest?.('a[href]')) mark();
    }, true);
    window.addEventListener('pagehide', (event) => { if (!event.persisted && !dialog?.open) mark(); });

    /* Défilement explicite : instantané, ou doux après un clic hors mouvement réduit. Cible sous l'en-tête collant
       (scroll-padding-top de fs-nav.css). */
    const scrollToTarget = (target, animate = false) => {
      if (target === 'top') { window.scrollTo({ top: 0, behavior: animate && !reducedMotion() ? 'smooth' : 'instant' }); return; }
      target?.scrollIntoView({ block: 'start', behavior: animate && !reducedMotion() ? 'smooth' : 'instant' });
    };
    const catalogAnchor = () => root.querySelector('[data-fs-catalog-anchor]') || catalogue;
    const here = () => navCore.parse(window.location.href);

    /* Navigation vers un écran (clic) : nouvelle entrée (ou entrée courante remplacée : replaceEntry), écran posé, puis
       position (scroll : 'top', un élément, ou une fonction) et focus. */
    const go = (target, { scroll = 'top', focus = null, animate = true, keepFilters = false, from = null, replaceEntry = false } = {}) => {
      const href = navCore.build(window.location.href, target, { keepFilters });
      if (replaceEntry) writeEntry({ fs: 1, y: Math.round(window.scrollY) }, href);
      else if (href === window.location.href) replace(href); else push(href, {}, from);
      /* Changement d'univers : la position se pose dans la View Transition, instantanée comme une page. */
      const wanted = screenOf(target).universe;
      const smooth = animate && (root.dataset.fsUniverse || DEFAULT_UNIVERSE) === wanted;
      show(target, {
        animate,
        then: () => {
          if (typeof scroll === 'function') scroll();
          else if (scroll === 'top') scrollToTarget('top');
          else if (scroll) scrollToTarget(scroll, smooth);
          const node = typeof focus === 'function' ? focus() : focus;
          node?.focus({ preventScroll: true });
        },
      });
    };
    const goHome = (options = {}) => go({}, { scroll: 'top', focus: () => root.querySelector('#fs-hero-title'), ...options });
    const goGame = (game, options = {}) => go({ univers: game }, { scroll: 'top', focus: () => root.querySelector('#fs-hero-title'), ...options });
    const catalogTitle = () => root.querySelector('#fs-catalogue-title');
    const goCatalogue = (game, options = {}) => {
      go({ univers: game, hash: '#fs-catalog' }, { scroll: catalogAnchor(), focus: catalogTitle, ...options });
    };
    /* Entrée dans un jeu depuis le catalogue (rubrique « Jeu » des filtres, « Voir toutes les annonces ») : même écran
       que la tuile du portail (univers, habillage, nouvelle entrée), recherche et tri gardés dans l'adresse, sans
       remonter en haut de page : le début du catalogue reste où il était à l'écran (ou revient sous l'en-tête s'il
       était passé au-dessus), le focus reste sur l'élément choisi. replace : l'entrée courante est remplacée (choix
       fait dans le tiroir des filtres, dont l'entrée d'historique devient celle du jeu). */
    const pick = (game, { from = null, replace: replaceEntry = false } = {}) => {
      const code = game === 'all' ? '' : navCore.game(game);
      if (game !== 'all' && !games.has(code)) return false;
      const anchor = catalogAnchor();
      const before = anchor?.getBoundingClientRect().top ?? 0;
      const keep = () => {
        if (!anchor) return;
        const header = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
        if (before < header) scrollToTarget(anchor);
        else window.scrollBy({ top: anchor.getBoundingClientRect().top - before, behavior: 'instant' });
      };
      go({ univers: code, hash: '#fs-catalog' }, { scroll: keep, focus: from, keepFilters: ['q', 'sort'], from, replaceEntry });
      return true;
    };

    /* Retour d'historique : écran, catalogue et fiche posés sans animation, puis position et focus de l'entrée. */
    window.addEventListener('popstate', () => {
      const target = here();
      const saved = entry();
      closeMenu();
      show(target, {
        animate: false,
        then: () => {
          /* Filtres, recherche et tri de cette entrée, relus depuis l'adresse avant de reposer la position. */
          try { window.FSListingFilters?.syncFromUrl?.(); } catch { /* filtres laissés en l'état */ }
          if (typeof saved.y === 'number') window.scrollTo({ top: saved.y, behavior: 'instant' });
          else if (target.hash) scrollToTarget(document.getElementById(target.hash.slice(1)));
          else window.scrollTo({ top: 0, behavior: 'instant' });
          if (!dialog?.open) findFocus(saved.focus)?.focus({ preventScroll: true });
        },
      });
    });

    /* Préférence de session : la tuile du dernier jeu visité est signalée (data-fs-last), sans redirection. */
    function markLast() {
      let last = '';
      try { last = sessionStorage.getItem('fs-game') || ''; } catch { /* aucune préférence */ }
      tiles.forEach((tile) => tile.toggleAttribute('data-fs-last', Boolean(last) && tile.dataset.fsGate === last));
    }

    /* ---- Liens de navigation interceptés (clic simple ; Ctrl/Cmd/Maj/clic milieu gardent le comportement natif) ---- */
    const plain = (event) => event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !event.defaultPrevented;
    const gameOfDetail = () => detail?.querySelector('[data-fs-ld]')?.getAttribute('data-game') || openCard?.dataset.game || '';
    root.addEventListener('click', (event) => {
      if (!plain(event)) return;
      const target = event.target;
      const tile = target.closest?.('[data-fs-world]');
      if (tile && root.contains(tile) && games.has(tile.dataset.fsWorld)) {
        event.preventDefault();
        goGame(tile.dataset.fsWorld, { from: tile });
        return;
      }
      /* « Toutes les annonces » de l'écran d'un jeu (rôle 4) : catalogue « Tous les jeux » de l'accueil. */
      const showAll = target.closest?.('[data-fs-show-all]');
      if (showAll) {
        event.preventDefault();
        go({ hash: '#fs-catalog' }, { scroll: catalogAnchor(), from: showAll, focus: catalogTitle });
        return;
      }
      const gameLink = target.closest?.('[data-fs-nav-game]');
      if (gameLink && navCore.game(gameLink.dataset.fsNavGame)) {
        event.preventDefault();
        if (dialog?.open) closeDetail('nav');
        goGame(navCore.game(gameLink.dataset.fsNavGame), { from: gameLink });
        return;
      }
      const crumb = target.closest?.('[data-fs-crumb]');
      if (crumb && crumb.matches('a')) {
        event.preventDefault();
        const game = gameOfDetail();
        closeDetail('nav');
        if (crumb.dataset.fsCrumb === 'game' && navCore.game(game)) goCatalogue(game, { animate: false });
        else goHome({ animate: false });
        return;
      }
      if (target.closest?.('[data-fs-detail-back]')) {
        event.preventDefault();
        closeDetail();
        return;
      }
      const home = target.closest?.('[data-fs-nav="home"]');
      if (home) {
        event.preventDefault();
        const { univers, annonce } = here();
        if (univers || annonce) { goHome({ from: home }); return; }
        scrollToTarget('top', true);
        root.querySelector('#fs-hero-title')?.focus({ preventScroll: true });
        return;
      }
      /* Ancres internes (#fs-catalog, #fs-how…) : navigation native (une entrée), position de départ gardée avant. */
      const anchor = target.closest?.('a[href^="#"]');
      if (anchor && !anchor.matches('[data-fs-propose-open]') && anchor.getAttribute('href').length > 1) mark(anchor);
    });
    /* « Proposer » : entrée #sell poussée avant que fs-propose.js (clic suivant, même document) ne défile.
       Depuis une fiche ouverte : la fiche est fermée et son entrée remplacée (Précédent revient au catalogue). */
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest?.('[data-fs-propose-open]');
      if (!trigger || !root.contains(trigger) || !plain(event)) return;
      if (dialog?.contains(trigger)) closeDetail('propose');
      enter('sell', trigger);
    }, true);
    function enter(section, from) {
      const hash = `#${section}`;
      const target = { ...here(), annonce: '', hash };
      const href = navCore.build(window.location.href, target, { keepFilters: true });
      if (href === window.location.href) return false;
      push(href, {}, from);
      return true;
    }
    root.querySelectorAll('[data-fs-gate-all]').forEach((button) => button.addEventListener('click', () => {
      go({ hash: '#fs-catalog' }, { scroll: catalogAnchor(), focus: catalogTitle, from: button });
    }));
    /* « Changer de jeu » : retour à l'accueil, focus sur la tuile du jeu quitté. */
    root.querySelectorAll('[data-fs-portal-open]').forEach((button) => button.addEventListener('click', () => {
      const left = screen;
      goHome({ from: button, focus: () => root.querySelector(`[data-fs-world="${CSS.escape(left)}"]`) || root.querySelector('#fs-hero-title') });
    }));

    /* Nombre d'annonces par jeu : donné par Liquid (data-fs-total), sinon compté sur les cartes chargées. */
    function syncCounts() {
      const cardsOf = (game) => cards.filter((card) => game === 'all' || card.dataset.game === game).length;
      const unitOf = (node) => (node?.dataset.fsUnit === 'exemple' ? 'exemple' : 'annonce');
      const phrase = (total, unit) => {
        if (!total) return t(unit === 'exemple' ? 'home.catalogue.no_examples' : 'home.catalogue.no_listings');
        return t(unit === 'exemple' ? 'home.catalogue.examples_count' : 'home.catalogue.published_count', { count: total });
      };
      const totalOf = (node, game) => {
        const given = Number(node?.dataset.fsTotal);
        return node?.dataset.fsTotal !== undefined && Number.isSafeInteger(given) ? given : cardsOf(game);
      };
      tiles.forEach((tile) => {
        const count = tile.querySelector('[data-fs-gate-count]');
        if (!count || count.dataset.fsTotal !== undefined) return;
        const total = cardsOf(tile.dataset.fsGate);
        const text = count.querySelector('[data-fs-gate-count-text]');
        if (text) text.textContent = phrase(total, unitOf(count));
      });
      const all = root.querySelector('[data-fs-all-count]');
      if (all && all.dataset.fsTotal === undefined && cards.length) {
        all.textContent = t(unitOf(root.querySelector('[data-fs-gate-count]')) === 'exemple' ? 'home.catalogue.examples_short' : 'common.listings_count', { count: cards.length });
      }
      const skin = root.getAttribute('data-fs-game-skin');
      const scope = root.querySelector('[data-fs-scope-count]');
      if (scope && skin) {
        const gate = root.querySelector(`[data-fs-gate="${CSS.escape(skin)}"] [data-fs-gate-count]`);
        scope.textContent = String(gate ? totalOf(gate, skin) : cardsOf(skin));
      }
    }

    /* ---- Fiche ---- */
    function cardHandle(card) {
      return navCore.handleOf({ handle: card?.dataset.fsHandle, game: card?.dataset.game, reference: card?.dataset.fsRef });
    }
    const cardFor = (wanted) => cards.find((card) => navCore.matches(wanted, { handle: card.dataset.fsHandle, game: card.dataset.game, reference: card.dataset.fsRef }));
    let openCard = null;
    let closingBy = '';
    /* Barre de retour et fil d'Ariane de la fiche (balisage du rôle 5) : libellés et adresses selon l'écran d'origine. */
    const dressDetail = (card) => {
      const game = card.dataset.game || '';
      const backLabel = screen === 'all' && current === 'all' ? t('common.all_listings') : t('home.catalogue.game_listings', { game: nameOf(screen === 'all' ? current : screen) });
      const gameHref = navCore.build(window.location.href, { univers: game, hash: '#fs-catalog' });
      detail.querySelectorAll('[data-fs-detail-back-label]').forEach((label) => { label.textContent = backLabel; });
      detail.querySelectorAll('a[data-fs-crumb="home"]').forEach((link) => { link.href = navCore.build(window.location.href, {}); });
      detail.querySelectorAll('a[data-fs-close-kind="all"]').forEach((link) => { link.href = navCore.build(window.location.href, { hash: '#fs-catalog' }); });
      detail.querySelectorAll('a[data-fs-crumb="game"], a[data-fs-close-kind="back"]').forEach((link) => { link.href = gameHref; });
    };
    /* Fiche : le visuel de la carte se déplace vers la fiche (View Transition), le commerce apparaît sans animation.
       push : nouvelle entrée &listing= (clic) ; sinon fiche posée sur l'entrée courante (accès direct, Précédent/Suivant). */
    const openDetail = (button, { push: pushEntry = true, morph = true } = {}) => {
      const card = button.closest('[data-fs-offer]');
      if (!card || !dialog || !detail) return;
      opener = button;
      openCard = card;
      const handle = cardHandle(card);
      if (pushEntry) {
        const href = handle ? navCore.build(window.location.href, { ...here(), hash: '', annonce: handle }, { keepFilters: true }) : window.location.href;
        push(href, { detail: true, detailDoc: docId }, button);
      }
      const art = card.querySelector('.fs-offer-art');
      const name = art?.dataset.fsVtName;
      const show = () => {
        /* La fiche prend la lumière de son propre univers (accent, halo) ; le commerce reste neutre. */
        const universe = card.getAttribute('data-fs-universe');
        if (universe && registry.has(universe)) dialog.setAttribute('data-fs-universe', universe);
        else dialog.removeAttribute('data-fs-universe');
        detail.replaceChildren(card.querySelector('template').content.cloneNode(true));
        dressDetail(card);
        if (!dialog.open) dialog.showModal();
        const title = detail.querySelector('#fs-detail-title');
        document.title = navCore.title({ detail: title?.textContent.trim().replace(/\s+/g, ' ') || '', reference: card.dataset.fsRef || '' });
        title?.focus();
        document.dispatchEvent(new CustomEvent('fs:detail-open', { detail: { handle, game: card.dataset.game || null, reference: card.dataset.fsRef || null } }));
      };
      const canMorph = morph && name && /^[a-z][a-z0-9_-]*$/i.test(name) && typeof document.startViewTransition === 'function'
        && !reducedMotion() && !card.hidden && art.getClientRects().length > 0;
      if (!canMorph) { show(); return; }
      try {
        art.style.viewTransitionName = name;
        const transition = startTransition(() => {
          art.style.viewTransitionName = '';
          show();
          const target = detail.querySelector('.fs-detail-art');
          if (target) target.style.viewTransitionName = name;
        }, 'fs-detail');
        transition.finished.finally(() => {
          art.style.viewTransitionName = '';
          const target = detail.querySelector('.fs-detail-art');
          if (target) target.style.viewTransitionName = '';
        }).catch(() => {});
      } catch {
        art.style.viewTransitionName = '';
        show();
      }
    };
    /* Fermeture demandée (×, Échap, fond, « ← Annonces… ») : Précédent si l'entrée vient de ce document, sinon
       l'adresse perd &listing=. by = 'router' (popstate), 'nav' (lien du fil d'Ariane), 'propose' (vers #sell). */
    function closeDetail(by = '') {
      if (!dialog?.open) return;
      closingBy = by;
      dialog.close();
    }
    /* Carte au-delà de la pagination de fs-filters.js (12 cartes, 8 sur mobile) : pages affichées jusqu'à elle. */
    const revealCard = (card) => {
      try { window.FSListingFilters?.reveal?.(card.dataset.fsRef || ''); } catch { /* carte laissée en place */ }
    };
    const syncDetail = (wanted) => {
      if (!wanted) { if (dialog?.open) closeDetail('router'); return; }
      const card = cardFor(wanted);
      if (!card) { if (dialog?.open) closeDetail('router'); return; }
      if (dialog?.open && openCard === card) return;
      revealCard(card);
      const button = card.querySelector('[data-fs-open]');
      if (button) openDetail(button, { push: false, morph: false });
    };
    root.querySelectorAll('[data-fs-open]').forEach((button) => button.addEventListener('click', () => openDetail(button)));
    dialog?.addEventListener('click', (event) => {
      const closer = event.target.closest?.('[data-fs-close]');
      if (closer) {
        /* Liens du fil d'Ariane (rôle 5) : « all » → toutes les annonces ; « back » → catalogue du jeu de la fiche
           (simple fermeture si la fiche a été ouverte depuis ce jeu). Boutons (← Annonces, ×) : fermeture. */
        const link = closer.matches('a');
        if (link && !plain(event)) return;
        if (link) event.preventDefault();
        const kind = link ? closer.dataset.fsCloseKind || '' : '';
        const game = gameOfDetail();
        if (kind === 'all') {
          closeDetail('nav');
          go({ hash: '#fs-catalog' }, { scroll: catalogAnchor(), animate: false, focus: catalogTitle });
        } else if (kind === 'back' && navCore.game(game) && game !== screen && game !== current) {
          closeDetail('nav');
          goCatalogue(game, { animate: false });
        } else closeDetail();
        return;
      }
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) closeDetail();
    });
    dialog?.addEventListener('close', () => {
      const by = closingBy;
      closingBy = '';
      const handle = cardHandle(openCard);
      openCard = null;
      document.title = screenTitle;
      document.dispatchEvent(new CustomEvent('fs:detail-close', { detail: { handle } }));
      if (by === 'router' || by === 'nav') return;
      const state = entry();
      const ownEntry = state.detail && state.detailDoc === docId;
      if (by === '' && ownEntry) { history.back(); return; }
      /* Accès direct, rechargement ou « Proposer » : l'entrée de la fiche devient celle du catalogue. */
      if (here().annonce || state.detail) replace(navCore.build(window.location.href, { ...here(), annonce: '' }, { keepFilters: true }), { detail: false, detailDoc: '' });
      if (by === '' && opener?.isConnected) opener.focus({ preventScroll: true });
    });
    detail?.addEventListener('click', (event) => {
      const button = event.target.closest('[data-fs-simulate]');
      if (!button) return;
      detail.querySelector('[data-fs-result]').textContent = t('home.demo.simulated_result');
      button.disabled = true;
      button.textContent = t('home.demo.simulated');
    });

    /* ---- En-tête : menu mobile, destination active, liens vers l'accueil ---- */
    const header = root.querySelector('[data-fs-site-header]');
    const menuToggle = header?.querySelector('[data-fs-menu-toggle]');
    const menu = header?.querySelector('[data-fs-site-nav]');
    function closeMenu(focusToggle = false) {
      if (!menuToggle || menuToggle.getAttribute('aria-expanded') !== 'true') return;
      menuToggle.setAttribute('aria-expanded', 'false');
      header.removeAttribute('data-fs-menu-open');
      if (focusToggle) menuToggle.focus();
    }
    menuToggle?.addEventListener('click', () => {
      const open = menuToggle.getAttribute('aria-expanded') !== 'true';
      menuToggle.setAttribute('aria-expanded', String(open));
      header.toggleAttribute('data-fs-menu-open', open);
      /* La navigation précède « Menu » dans le DOM (ordre visuel de l'en-tête) : le focus va à son premier lien. */
      if (open) menu?.querySelector('a')?.focus();
    });
    menu?.addEventListener('click', (event) => { if (event.target.closest('a')) closeMenu(); });
    header?.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(true); });
    document.addEventListener('click', (event) => { if (header && !header.contains(event.target)) closeMenu(); });
    /* Lien d'évitement et liens de section de l'en-tête : après le saut natif vers l'ancre, le focus va au titre de la
       section (tabindex="-1" posé au besoin), sans nouveau défilement. « Proposer » : fs-propose.js pose son focus. */
    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a.fs-skip, [data-fs-site-nav] a[data-fs-nav-section]');
      if (!link || link.matches('[data-fs-propose-open]') || !plain(event)) return;
      const target = document.getElementById((link.getAttribute('href') || '').slice(1));
      if (!target) return;
      setTimeout(() => {
        const heading = target.querySelector('h1, h2') || target;
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }, 0);
    });
    const syncHomeLinks = () => {
      root.querySelectorAll('a[data-fs-nav="home"]').forEach((link) => { link.href = navCore.build(window.location.href, {}); });
      root.querySelectorAll('a[data-fs-show-all]').forEach((link) => { link.href = navCore.build(window.location.href, { hash: '#fs-catalog' }); });
      root.querySelectorAll('a[data-fs-nav-game]').forEach((link) => { link.href = navCore.build(window.location.href, { univers: link.dataset.fsNavGame }); });
    };
    /* Destination active : la section qui croise la ligne de lecture (sous l'en-tête, au tiers haut de la fenêtre) porte
       aria-current sur son lien. Rien par image de défilement (Lenis défile depuis le fil principal) : un
       IntersectionObserver suit une bande d'un pixel à hauteur de la ligne ; aria-current n'est écrit que s'il change.
       scroll-padding-top (en-tête collant, fs-nav.css ; plus haut sous le formulaire de proposition, fs-propose-form.css)
       est relu au redimensionnement et une fois par geste de défilement, jamais par image. */
    const navLinks = [...(menu?.querySelectorAll('a[data-fs-nav-section]') ?? [])];
    const navSections = navLinks.map((link) => document.getElementById(link.dataset.fsNavSection)).filter(Boolean);
    let spyActive = null;
    const spyMark = (id) => {
      if (id === spyActive) return;
      spyActive = id;
      navLinks.forEach((link) => {
        if (id && link.dataset.fsNavSection === id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };
    let spyObserver = null;
    let spyLine = -1;
    const spyCrossing = new Set();
    const spy = () => {
      if (!navSections.length || typeof IntersectionObserver !== 'function') return;
      const height = window.innerHeight;
      const line = Math.round(Math.max((parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0) + 24, height * 0.3));
      if (spyObserver && line === spyLine) return;
      spyLine = line;
      spyObserver?.disconnect();
      spyCrossing.clear();
      const seen = (entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) spyCrossing.add(entry.target); else spyCrossing.delete(entry.target); });
        spyMark(navSections.filter((section) => spyCrossing.has(section)).pop()?.id || '');
      };
      /* Bande [ligne, ligne + 1 px] de la fenêtre du document (root: document : juste aussi dans un cadre). */
      const options = { rootMargin: `${-line}px 0px ${Math.min(0, line + 1 - height)}px 0px` };
      try { spyObserver = new IntersectionObserver(seen, { ...options, root: document }); } catch { spyObserver = new IntersectionObserver(seen, options); }
      navSections.forEach((section) => spyObserver.observe(section));
    };
    let spyFrame = 0;
    let spyScrollAt = -Infinity;
    const spyLater = () => { if (!spyFrame) spyFrame = requestAnimationFrame(() => { spyFrame = 0; spy(); }); };
    window.addEventListener('resize', spyLater, { passive: true });
    window.addEventListener('scroll', () => {
      const now = performance.now();
      if (now - spyScrollAt > 300) spyLater();
      spyScrollAt = now;
    }, { passive: true });

    window.FSNav = Object.freeze({
      state: () => ({ view: screen === 'all' && !root.hasAttribute('data-fs-game-skin') ? 'portal' : 'game', game: screen === 'all' ? null : screen, catalogGame: current, annonce: here().annonce || null }),
      href: (target = {}, options = {}) => navCore.build(window.location.href, target, options),
      pick: (game, options = {}) => pick(String(game || ''), options),
      closeDetail: () => closeDetail(),
      enter: (section) => enter(String(section || '').replace(/^#/, '')),
    });

    /* ---- État initial : l'adresse décide (univers posé par le moteur et le script d'avant-rendu) ---- */
    const canonical = navCore.canonical(window.location.href);
    if (canonical) writeEntry(history.state, canonical);
    const start = here();
    const startScreen = screenOf(start.univers ? start : { univers: root.dataset.fsUniverse || '' });
    const startUniverse = startScreen.universe;
    screen = startScreen.game;
    filter(screen);
    applySkin(root.dataset.fsUniverse || DEFAULT_UNIVERSE);
    if (root.dataset.fsUniverse && root.dataset.fsUniverse !== DEFAULT_UNIVERSE) remember(root.dataset.fsUniverse);
    speak(screen);
    skinCards();
    markLast();
    syncHomeLinks();
    const align = () => {
      if (root.dataset.fsUniverse === startUniverse) return;
      if (window.FSUniverse && typeof window.FSUniverse.set === 'function') {
        try { window.FSUniverse.set(startUniverse, { source: 'url', viewTransition: false }); } catch { /* univers posé par le script d'avant-rendu */ }
      } else root.setAttribute('data-fs-universe', startUniverse);
    };
    /* Le moteur lit lui-même ?game= à son démarrage ; s'il n'a pas pu se charger, le repli pose l'attribut. */
    if (startUniverse !== DEFAULT_UNIVERSE) {
      if (window.FSUniverse || document.readyState === 'complete') align();
      else window.addEventListener('load', align, { once: true });
    }
    /* Rechargement ou retour d'un autre site : position de l'entrée (défilement manuel), gardée jusqu'au premier
       geste ; fiche demandée par l'adresse ouverte par-dessus sa carte. */
    const saved = entry();
    writeEntry({ ...saved, fs: 1 });
    let touched = false;
    ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach((type) => window.addEventListener(type, () => { touched = true; }, { once: true, passive: true, capture: true }));
    const restore = () => {
      if (touched || dialog?.open) return;
      if (typeof saved.y === 'number' && saved.y > 0) window.scrollTo({ top: saved.y, behavior: 'instant' });
    };
    /* Annonce Discord : sa fiche est sa page (/pages/listings/<handle>). L'ancienne adresse ?listing= y renvoie (déjà fait
       par le script en tête de la section ; repli ici), paramètres gérés retirés, fragment gardé. */
    const pageOf = (card) => card?.querySelector('[data-fs-listing-link]')?.getAttribute('href') || '';
    if (start.annonce && pageOf(cardFor(start.annonce))) {
      const url = new URL(window.location.href);
      ['listing', 'game', 'annonce', 'univers', 'jeu', 'f', 'q', 'sort', 'compare', 'tri', 'comparer'].forEach((name) => url.searchParams.delete(name));
      window.location.replace(`${pageOf(cardFor(start.annonce))}${url.search}${url.hash}`);
    } else if (start.annonce) {
      const card = cardFor(start.annonce);
      if (card) {
        const button = card.querySelector('[data-fs-open]');
        if (button) openDetail(button, { push: false, morph: false });
        /* Carte placée derrière la fiche une fois la pagination des filtres posée (fs-filters.js démarre au DOMContentLoaded). */
        const place = () => {
          revealCard(card);
          if (typeof saved.y === 'number') window.scrollTo({ top: saved.y, behavior: 'instant' });
          else card.scrollIntoView({ block: 'center', behavior: 'instant' });
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(place, 0), { once: true });
        else place();
      } else {
        replace(navCore.build(window.location.href, { ...start, annonce: '' }, { keepFilters: true }), { detail: false });
        const notice = document.createElement('p');
        notice.className = 'fs-alert fs-nav-notice';
        notice.setAttribute('role', 'status');
        catalogue?.prepend(notice);
        /* Texte posé après l'insertion : annoncé par les lecteurs d'écran. */
        requestAnimationFrame(() => { notice.textContent = t('home.catalogue.not_shown'); });
        if (typeof saved.y !== 'number') scrollToTarget(catalogue);
      }
    } else if (typeof saved.y === 'number') {
      restore();
      if (document.readyState !== 'complete') window.addEventListener('load', restore, { once: true });
    }
    spy();
    root.dataset.fsInteractive = 'true';
  };
  document.querySelectorAll('[data-fs-demo]').forEach(initialise);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-fs-demo]').forEach(initialise));
})();
